export default "__VITE_ASSET__DvWYgRdY__"